// Resolution order (most-specific wins):
//   1. window.__APP_CONFIG__.apiBaseUrl — injected by the Docker entrypoint
//      at container start (see docker/entrypoint.sh). Lets the same image
//      be re-pointed at a different backend without a rebuild.
//   2. VUE_APP_API_HOST — build-time fallback for `npm run serve` / dev.
//   3. Prod default — used when neither of the above is set.
const runtime =
  (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

// Only reached when config.js has not been written — a `npm run serve` session
// with no VUE_APP_API_HOST. The deployed panel always has a runtime config.
//
// Was a hardcoded IP over plain HTTP, which sent admin session tokens in the
// clear to whatever happened to answer on that address.
const buildTimeHost =
  process.env.VUE_APP_API_HOST || "https://api-dev.preevnt.app";

export const API_BASE_URL =
  (runtime.apiBaseUrl && String(runtime.apiBaseUrl)) || `${buildTimeHost}/api`;

// Some callers need the host without /api (profile photo URLs hang off /storage/...).
export const API_HOST = API_BASE_URL.replace(/\/+api\/?$/, "");
